// extracted by mini-css-extract-plugin
export default {"container":"DiceContainer_container__9--Ui","tray":"DiceContainer_tray__TKhMI"};